package com.anjuros.website.redesign.sections.blogarticle

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdBreadcrumb
import com.anjuros.website.redesign.components.RdCrumb
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.sections.blog.BlogMeta
import com.anjuros.website.redesign.sections.blog.RdBlogGuide
import com.anjuros.website.redesign.styles.ArticleBylineStyle
import com.anjuros.website.redesign.styles.ArticleCoverStyle
import com.anjuros.website.redesign.styles.ArticleHeadStyle
import com.anjuros.website.redesign.styles.ArticleTitleStyle
import com.anjuros.website.redesign.styles.RdWrapStyle
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Breadcrumb, topic, date and reading time, the title, the author and the cover picture. */
@Composable
fun ArticleHeadSection(guide: RdBlogGuide) {
    val title = LocalText(guide.card.title)
    Div(RdWrapStyle.toModifier().toAttrs()) {
        Div(ArticleHeadStyle.toModifier().toAttrs()) {
            RdBreadcrumb(title, listOf(RdCrumb(RdText.BLOG_CRUMB, RdRoute.BLOG)))
            BlogMeta(guide)
            H1(ArticleTitleStyle.toModifier().id("h1").toAttrs()) { Text(title) }
            RdLink(RdRoute.ABOUT, ArticleBylineStyle.toModifier()) {
                RdPicture(RdImage.AVATAR, alt = "", lazy = false)
                Span {
                    Text(LocalText(RdText.BLOG_BY_START))
                    B { Text(LocalText(RdText.BLOG_BY_NAME)) }
                    Text(LocalText(RdText.BLOG_BY_END))
                }
            }
        }
        RdTag("figure", ArticleCoverStyle.toModifier()) { RdPicture(guide.image, title, lazy = false) }
    }
}
